'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);

// Adopted from: https://github.com/foray1010/use-typed-event-listener

function useEventListener(eventName, handler) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : global;
  var options = arguments.length > 3 ? arguments[3] : undefined;
  var savedHandler = React.useRef(handler);
  savedHandler.current = handler;
  var _ref = options !== null && options !== void 0 ? options : {},
    capture = _ref.capture,
    passive = _ref.passive,
    once = _ref.once;
  React.useEffect(function () {
    var isSupported = !!(element !== null && element !== void 0 && element.addEventListener);
    if (!isSupported) {
      return;
    }
    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };
    var opts = {
      capture: capture,
      passive: passive,
      once: once
    };
    element.addEventListener(eventName, eventListener, opts);
    return function () {
      element.removeEventListener(eventName, eventListener, opts);
    };
  }, [eventName, element, capture, passive, once, savedHandler]);
}

module.exports = useEventListener;
